import { jsxs as _, jsx as n, Fragment as de } from "react/jsx-runtime";
import { c as R, I as V } from "./Section-DOeCOW54.js";
import ee, { useState as Q, useCallback as W, useEffect as ae } from "react";
import { T as h, I as J, u as te, B as K } from "./useMediaQuery-BZAMobKw.js";
import { P as _e } from "./Picture-JvtjNict.js";
import { g as Z, a as ue, C as j } from "./ImageCarousel-rVtFRbaH.js";
import { u as pe, S as re, m as fe, G as me, C as be, a as ye, M as ge, I as oe } from "./ApartmentCard-BfyZfamk.js";
import { T as ie } from "./TextHtml-Cpd1SvM0.js";
const he = "elo-mobile", Ae = "elo-tablet", se = {
  "float-link": "elo-float-link",
  "float-link__text": "elo-float-link__text",
  mobile: he,
  tablet: Ae
}, Ue = ee.forwardRef(
  ({ iconLeft: t, iconRight: e, children: r, ...i }, l) => {
    const s = R(se["float-link"], i.className);
    return /* @__PURE__ */ _("a", { ...i, ref: l, className: s, children: [
      t && /* @__PURE__ */ n(V, { name: t }),
      r && /* @__PURE__ */ n(
        h,
        {
          type: "span",
          size: "medium",
          extraClass: se["float-link__text"],
          children: r
        }
      ),
      e && /* @__PURE__ */ n(V, { name: e })
    ] });
  }
), z = {
  "info-card": "elo-info-card",
  "info-card__icon": "elo-info-card__icon",
  "info-card__icon--transparent": "elo-info-card__icon--transparent",
  "info-card__icon--primary": "elo-info-card__icon--primary",
  "info-card__icon--secondary": "elo-info-card__icon--secondary",
  "info-card__icon--tertiary": "elo-info-card__icon--tertiary",
  "info-card__icon--quaternary": "elo-info-card__icon--quaternary",
  "info-card__title": "elo-info-card__title",
  "info-card__description": "elo-info-card__description",
  "info-card__description--transparent": "elo-info-card__description--transparent"
}, ve = ({
  icon: t,
  type: e = "transparent",
  title: r,
  description: i
}) => {
  const l = R(z["info-card__icon"], {
    [z["info-card__icon--transparent"]]: e === "transparent",
    [z["info-card__icon--primary"]]: e === "primary",
    [z["info-card__icon--secondary"]]: e === "secondary",
    [z["info-card__icon--tertiary"]]: e === "tertiary",
    [z["info-card__icon--quaternary"]]: e === "quaternary"
  }), s = R(z["info-card__title"]), c = R(
    z["info-card__description"],
    e === "transparent" && z["info-card__description--transparent"]
  );
  return /* @__PURE__ */ _("div", { className: z["info-card"], children: [
    /* @__PURE__ */ n(V, { name: t, className: l, height: "34px", width: "34px" }),
    /* @__PURE__ */ n(
      h,
      {
        type: e !== "transparent" ? "heading" : "label",
        size: e !== "transparent" ? "xsmall" : "medium",
        extraClass: s,
        children: r
      }
    ),
    /* @__PURE__ */ n(h, { type: "paragraph", size: "medium", extraClass: c, children: i })
  ] });
}, Ce = "elo-tablet", Se = "elo-mobile", we = {
  "info-banner": "elo-info-banner",
  "info-banner--top-rounded": "elo-info-banner--top-rounded",
  "info-banner--reverse": "elo-info-banner--reverse",
  "info-banner--primary": "elo-info-banner--primary",
  "info-banner--secondary": "elo-info-banner--secondary",
  "info-banner--tertiary": "elo-info-banner--tertiary",
  "info-banner--quaternary": "elo-info-banner--quaternary",
  "info-banner__image-container": "elo-info-banner__image-container",
  "info-banner__image-container__balls-container": "elo-info-banner__image-container__balls-container",
  "info-banner__image-container__balls-container--right": "elo-info-banner__image-container__balls-container--right",
  "info-banner__image-container__balls-container__ball": "elo-info-banner__image-container__balls-container__ball",
  "info-banner__image-container__balls-container__ball--primary": "elo-info-banner__image-container__balls-container__ball--primary",
  "info-banner__image-container__balls-container__ball--secondary": "elo-info-banner__image-container__balls-container__ball--secondary",
  "info-banner__image-container__balls-container__ball--tertiary": "elo-info-banner__image-container__balls-container__ball--tertiary",
  "info-banner__image-container__balls-container__ball--quaternary": "elo-info-banner__image-container__balls-container__ball--quaternary",
  tablet: Ce,
  mobile: Se,
  "info-banner__image-container__image": "elo-info-banner__image-container__image",
  "info-banner__content": "elo-info-banner__content",
  "info-banner__content__title-container": "elo-info-banner__content__title-container",
  "info-banner__content__title-container__title": "elo-info-banner__content__title-container__title",
  "info-banner__content__description-container": "elo-info-banner__content__description-container",
  "info-banner__content__description-container__description": "elo-info-banner__content__description-container__description",
  "info-banner__content__description-container__description__title": "elo-info-banner__content__description-container__description__title",
  "info-banner__content__link": "elo-info-banner__content__link"
}, We = ({
  alignLeft: t = !0,
  topRounded: e = !0,
  variant: r,
  src: i,
  subtitle: l,
  title: s,
  descriptionTitle: c,
  description: f,
  linkLabel: d,
  linkUrl: g,
  iconLeft: m,
  iconRight: S
}) => {
  const {
    "info-banner": w,
    "info-banner--reverse": y,
    "info-banner--top-rounded": A,
    "info-banner--primary": D,
    "info-banner--secondary": I,
    "info-banner--tertiary": u,
    "info-banner--quaternary": a,
    "info-banner__image-container": x,
    "info-banner__image-container__balls-container": L,
    "info-banner__image-container__balls-container--right": P,
    "info-banner__image-container__balls-container__ball": T,
    "info-banner__image-container__balls-container__ball--primary": N,
    "info-banner__image-container__balls-container__ball--secondary": k,
    "info-banner__image-container__balls-container__ball--tertiary": b,
    "info-banner__image-container__balls-container__ball--quaternary": v,
    "info-banner__image-container__image": E,
    "info-banner__content": p,
    "info-banner__content__title-container": F,
    "info-banner__content__title-container__title": O,
    "info-banner__content__description-container": G,
    "info-banner__content__description-container__description__title": C,
    "info-banner__content__description-container__description": U,
    "info-banner__content__link": o
  } = we, M = R(w, {
    [A]: e,
    [D]: r === "primary",
    [I]: r === "secondary",
    [u]: r === "tertiary",
    [a]: r === "quaternary",
    [y]: !t
  }), B = R(L, {
    [P]: !t
  }), q = R(T, {
    [N]: r === "primary",
    [k]: r === "secondary",
    [b]: r === "tertiary",
    [v]: r === "quaternary"
  });
  return /* @__PURE__ */ _("div", { className: M, children: [
    /* @__PURE__ */ _("div", { className: x, children: [
      /* @__PURE__ */ _("div", { className: B, children: [
        /* @__PURE__ */ n("div", { className: q }),
        /* @__PURE__ */ n("div", { className: q }),
        /* @__PURE__ */ n("div", { className: q })
      ] }),
      /* @__PURE__ */ n(_e, { defaultSrc: i, alt: s, className: E, src: [] })
    ] }),
    /* @__PURE__ */ _("div", { className: p, children: [
      /* @__PURE__ */ _("div", { className: F, children: [
        l && /* @__PURE__ */ n(h, { type: "heading", size: "xsmall", extraClass: O, children: l }),
        s && s.length > 0 && /* @__PURE__ */ n(h, { type: "heading", size: "medium", extraClass: O, children: s })
      ] }),
      /* @__PURE__ */ _("div", { className: G, children: [
        c && c.length > 0 && /* @__PURE__ */ n(
          h,
          {
            type: "paragraph",
            size: "medium",
            extraClass: C,
            children: c
          }
        ),
        f && f.length > 0 && /* @__PURE__ */ n(h, { type: "paragraph", size: "medium", extraClass: U, children: f })
      ] }),
      d && g && d.length > 0 && /* @__PURE__ */ n(
        J,
        {
          variant: "primary",
          size: "large",
          className: o,
          href: g,
          iconLeft: m,
          iconRight: S,
          children: d
        }
      )
    ] })
  ] });
}, ke = "elo-tablet", Ee = "elo-mobile", $ = {
  "contact-banner": "elo-contact-banner",
  "contact-banner--top-rounded": "elo-contact-banner--top-rounded",
  "contact-banner--reverse": "elo-contact-banner--reverse",
  "contact-banner--primary": "elo-contact-banner--primary",
  "contact-banner--secondary": "elo-contact-banner--secondary",
  "contact-banner--tertiary": "elo-contact-banner--tertiary",
  "contact-banner--transparent": "elo-contact-banner--transparent",
  "contact-banner__image-container": "elo-contact-banner__image-container",
  "contact-banner__image-container__image": "elo-contact-banner__image-container__image",
  "contact-banner__content": "elo-contact-banner__content",
  "contact-banner__content__title-container": "elo-contact-banner__content__title-container",
  "contact-banner__content__title-container__title": "elo-contact-banner__content__title-container__title",
  tablet: ke,
  mobile: Ee,
  "contact-banner__content__personnel-info": "elo-contact-banner__content__personnel-info",
  "contact-banner__content__personnel-info__item": "elo-contact-banner__content__personnel-info__item",
  "contact-banner__content__personnel-info__item__name": "elo-contact-banner__content__personnel-info__item__name",
  "contact-banner__content__link": "elo-contact-banner__content__link",
  "contact-banner__text-link": "elo-contact-banner__text-link"
}, Ze = ({
  alignLeft: t = !0,
  topRounded: e = !0,
  variant: r,
  src: i,
  subtitle: l,
  title: s,
  name: c,
  jobTitle: f,
  phoneNumber: d,
  linkLabel: g,
  linkUrl: m,
  iconLeft: S,
  iconRight: w,
  email: y
}) => {
  const {
    "contact-banner": A,
    "contact-banner--reverse": D,
    "contact-banner--top-rounded": I,
    "contact-banner--primary": u,
    "contact-banner--secondary": a,
    "contact-banner--tertiary": x,
    "contact-banner--transparent": L,
    "contact-banner__image-container": P,
    "contact-banner__image-container__image": T,
    "contact-banner__content": N,
    "contact-banner__content__title-container": k,
    "contact-banner__content__title-container__title": b,
    "contact-banner__content__personnel-info": v,
    "contact-banner__content__personnel-info__item": E,
    "contact-banner__content__personnel-info__item__name": p,
    "contact-banner__content__link": F
  } = $, O = R(A, {
    [I]: e,
    [u]: r === "primary",
    [a]: r === "secondary",
    [x]: r === "tertiary",
    [L]: r === "transparent",
    [D]: !t
  });
  return /* @__PURE__ */ _("div", { className: O, id: "contact", children: [
    /* @__PURE__ */ n("div", { className: P, children: /* @__PURE__ */ n(_e, { src: [], defaultSrc: i, alt: s, className: T }) }),
    /* @__PURE__ */ _("div", { className: N, children: [
      /* @__PURE__ */ _("div", { className: k, children: [
        l && /* @__PURE__ */ n(h, { type: "heading", size: "xsmall", extraClass: b, children: l }),
        s && s.length > 0 && /* @__PURE__ */ n(h, { type: "heading", size: "medium", extraClass: b, children: s })
      ] }),
      /* @__PURE__ */ _("div", { className: v, children: [
        c && c.length > 0 && /* @__PURE__ */ n(
          h,
          {
            type: "paragraph",
            size: "medium",
            extraClass: p,
            children: c
          }
        ),
        f && f.length > 0 && /* @__PURE__ */ n(
          h,
          {
            type: "paragraph",
            size: "medium",
            extraClass: E,
            children: f
          }
        ),
        d && d.length > 0 && /* @__PURE__ */ n(
          h,
          {
            type: "paragraph",
            size: "medium",
            extraClass: E,
            children: /* @__PURE__ */ _(
              "a",
              {
                href: `tel:${d}`,
                className: $["contact-banner__text-link"],
                children: [
                  d,
                  " "
                ]
              }
            )
          }
        ),
        y && y.length > 0 && /* @__PURE__ */ n(
          h,
          {
            type: "paragraph",
            size: "medium",
            extraClass: E,
            children: /* @__PURE__ */ _(
              "a",
              {
                href: `mailto:${y}`,
                className: $["contact-banner__text-link"],
                children: [
                  y,
                  " "
                ]
              }
            )
          }
        ),
        g && m && g.length > 0 && /* @__PURE__ */ n(
          J,
          {
            variant: "primary",
            small: !1,
            className: F,
            href: m,
            iconLeft: S,
            iconRight: w,
            children: g
          }
        )
      ] })
    ] })
  ] });
};
function Be(t) {
  let {
    swiper: e,
    extendParams: r,
    on: i,
    emit: l,
    params: s
  } = t;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, r({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let c, f, d = s && s.autoplay ? s.autoplay.delay : 3e3, g = s && s.autoplay ? s.autoplay.delay : 3e3, m, S = (/* @__PURE__ */ new Date()).getTime(), w, y, A, D, I, u, a;
  function x(o) {
    !e || e.destroyed || !e.wrapperEl || o.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", x), !(a || o.detail && o.detail.bySwiperTouchMove) && v());
  }
  const L = () => {
    if (e.destroyed || !e.autoplay.running) return;
    e.autoplay.paused ? w = !0 : w && (g = m, w = !1);
    const o = e.autoplay.paused ? m : S + g - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = o, l("autoplayTimeLeft", o, o / d), f = requestAnimationFrame(() => {
      L();
    });
  }, P = () => {
    let o;
    return e.virtual && e.params.virtual.enabled ? o = e.slides.filter((B) => B.classList.contains("swiper-slide-active"))[0] : o = e.slides[e.activeIndex], o ? parseInt(o.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, T = (o) => {
    if (e.destroyed || !e.autoplay.running) return;
    cancelAnimationFrame(f), L();
    let M = typeof o > "u" ? e.params.autoplay.delay : o;
    d = e.params.autoplay.delay, g = e.params.autoplay.delay;
    const B = P();
    !Number.isNaN(B) && B > 0 && typeof o > "u" && (M = B, d = B, g = B), m = M;
    const q = e.params.speed, ne = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(q, !0, !0), l("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, q, !0, !0), l("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(q, !0, !0), l("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, q, !0, !0), l("autoplay")), e.params.cssMode && (S = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        T();
      })));
    };
    return M > 0 ? (clearTimeout(c), c = setTimeout(() => {
      ne();
    }, M)) : requestAnimationFrame(() => {
      ne();
    }), M;
  }, N = () => {
    S = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = !0, T(), l("autoplayStart");
  }, k = () => {
    e.autoplay.running = !1, clearTimeout(c), cancelAnimationFrame(f), l("autoplayStop");
  }, b = (o, M) => {
    if (e.destroyed || !e.autoplay.running) return;
    clearTimeout(c), o || (u = !0);
    const B = () => {
      l("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", x) : v();
    };
    if (e.autoplay.paused = !0, M) {
      I && (m = e.params.autoplay.delay), I = !1, B();
      return;
    }
    m = (m || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - S), !(e.isEnd && m < 0 && !e.params.loop) && (m < 0 && (m = 0), B());
  }, v = () => {
    e.isEnd && m < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (S = (/* @__PURE__ */ new Date()).getTime(), u ? (u = !1, T(m)) : T(), e.autoplay.paused = !1, l("autoplayResume"));
  }, E = () => {
    if (e.destroyed || !e.autoplay.running) return;
    const o = Z();
    o.visibilityState === "hidden" && (u = !0, b(!0)), o.visibilityState === "visible" && v();
  }, p = (o) => {
    o.pointerType === "mouse" && (u = !0, a = !0, !(e.animating || e.autoplay.paused) && b(!0));
  }, F = (o) => {
    o.pointerType === "mouse" && (a = !1, e.autoplay.paused && v());
  }, O = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", p), e.el.addEventListener("pointerleave", F));
  }, G = () => {
    e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", p), e.el.removeEventListener("pointerleave", F));
  }, C = () => {
    Z().addEventListener("visibilitychange", E);
  }, U = () => {
    Z().removeEventListener("visibilitychange", E);
  };
  i("init", () => {
    e.params.autoplay.enabled && (O(), C(), N());
  }), i("destroy", () => {
    G(), U(), e.autoplay.running && k();
  }), i("_freeModeStaticRelease", () => {
    (A || u) && v();
  }), i("_freeModeNoMomentumRelease", () => {
    e.params.autoplay.disableOnInteraction ? k() : b(!0, !0);
  }), i("beforeTransitionStart", (o, M, B) => {
    e.destroyed || !e.autoplay.running || (B || !e.params.autoplay.disableOnInteraction ? b(!0, !0) : k());
  }), i("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        k();
        return;
      }
      y = !0, A = !1, u = !1, D = setTimeout(() => {
        u = !0, A = !0, b(!0);
      }, 200);
    }
  }), i("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !y)) {
      if (clearTimeout(D), clearTimeout(c), e.params.autoplay.disableOnInteraction) {
        A = !1, y = !1;
        return;
      }
      A && e.params.cssMode && v(), A = !1, y = !1;
    }
  }), i("slideChange", () => {
    e.destroyed || !e.autoplay.running || (I = !0);
  }), Object.assign(e.autoplay, {
    start: N,
    stop: k,
    pause: b,
    resume: v
  });
}
const Te = "elo-carousel__controls", xe = "elo-carousel__track", le = {
  carousel__controls: Te,
  "carousel__button-controls": "elo-carousel__button-controls",
  carousel__track: xe
}, je = ee.forwardRef(
  ({
    autoPlay: t,
    pauseButton: e,
    slidesToShowMobile: r,
    slidesToShowDesktop: i,
    slidesToShowTablet: l,
    slidesToShowLargeDesktop: s,
    displayArrows: c,
    children: f,
    speed: d,
    loop: g,
    ...m
  }, S) => {
    var b, v, E;
    const [w, y] = Q(0), [A, D] = Q(!1), [I, u] = Q(!1), [a, x] = Q(), [L, P] = Q(0), T = W(() => {
      var p;
      a && (a.wrapperEl.style.transitionDuration = `${a.params.speed}ms`, a.el.classList.remove("paused"), (p = a.autoplay) == null || p.start());
    }, [a]), N = W(() => {
      var p;
      a && (a.wrapperEl.style.transitionDuration = "0s", a.el.classList.add("paused"), (p = a.autoplay) == null || p.stop());
    }, [a]), k = W(() => {
      a && (a.autoplay.running ? N() : T());
    }, [T, N, a]);
    return ae(() => {
      if (!a) return;
      const p = () => {
        u(!1);
      }, F = () => {
        u(!0);
      };
      return a.on("autoplayStart", p), a.on("autoplayStop", F), () => {
        a.off("autoplayStart", p), a.off("autoplayStop", F);
      };
    }, [a]), ae(() => {
      if (a) {
        const p = () => {
          P(a.params.slidesPerView);
        };
        return p(), window.addEventListener("resize", p), () => {
          window.removeEventListener("resize", p);
        };
      }
      return () => {
      };
    }, [a]), /* @__PURE__ */ n("div", { ref: S, children: /* @__PURE__ */ _(
      ue,
      {
        onSwiper: x,
        slidesPerView: r,
        spaceBetween: 16,
        breakpoints: {
          // when window width is >= 600- Tablet
          600: {
            slidesPerView: l,
            spaceBetween: 24
          },
          // when window width is >= 1024- Desktop
          1024: {
            slidesPerView: i,
            spaceBetween: 24
          },
          1600: {
            slidesPerView: s || i
          }
        },
        autoplay: {
          delay: 0,
          disableOnInteraction: !1
        },
        onSlideChange: (p) => {
          y(p.realIndex), A && D(!1);
        },
        onReachEnd: () => D(!0),
        speed: d,
        loop: g ? !0 : !!t,
        slidesPerGroup: 1,
        loopAddBlankSlides: !0,
        watchSlidesProgress: !0,
        modules: t ? [Be] : [],
        ...m,
        children: [
          f,
          (e || c) && /* @__PURE__ */ _("div", { className: le.carousel__controls, children: [
            /* @__PURE__ */ n("div", { children: e && /* @__PURE__ */ n(
              j,
              {
                variant: "pause",
                onClick: k,
                disabled: (((b = a == null ? void 0 : a.slides) == null ? void 0 : b.length) ?? 0) < L,
                children: /* @__PURE__ */ n(
                  V,
                  {
                    name: I ? "Play" : "Pause",
                    width: "24",
                    height: "24"
                  }
                )
              }
            ) }),
            c && /* @__PURE__ */ _("div", { className: le["carousel__button-controls"], children: [
              /* @__PURE__ */ n(
                j,
                {
                  variant: "prev",
                  disabled: w === 0 && !t || (((v = a == null ? void 0 : a.slides) == null ? void 0 : v.length) ?? 0) < L,
                  autoplay: t,
                  currentIndex: w,
                  children: /* @__PURE__ */ n(V, { name: "ArrowLeftAlt", width: "24", height: "24" })
                }
              ),
              /* @__PURE__ */ n(
                j,
                {
                  variant: "next",
                  disabled: A && !t || (((E = a == null ? void 0 : a.slides) == null ? void 0 : E.length) ?? 0) < L,
                  autoplay: t,
                  currentIndex: w,
                  children: /* @__PURE__ */ n(V, { name: "ArrowRightAlt", width: "24", height: "24" })
                }
              )
            ] })
          ] })
        ]
      }
    ) });
  }
), Le = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAzNJREFUeF7tnGFu2zAMhd2TrT3Z1pN1Pdk2ATHgFrP1xBeKSvsZyK9IJPU+0o7F2E8bR6kCT6Xecb4BoDgJAACAYgWK3VMBAChWoNg9FQCAYgWK3VMBAChWoNg9FfCgAH4d4v4xaQ3v27b9vn0mucx3E6mAJv7P/NBOPTQIr18FxAiA523b3gqF/+x6JPaFwv4YysgimvgNwipHq4LjqXCVuIbiUAGslv37ItX4h0SZOVhdwKoAXh79WqACOLvw7hfE7KRpCfC/C//Dn4ZcALMEOEuAWf7TEgwAadJqhgGg6ZQ2CgBp0mqGAaDplDYKAGnSaoYBoOmUNgoAadJqhgGg6ZQ2ygXQ7oRnHGebgLP899YY7lW4AHqBfbfvh3sVAMhJEVVX+c+51V2wHJnyrMp7VCopAIzDkrbKATAurDpDqgIXQHU/YJb/K9GtXoULQKKspszFuJX7AVZsAPCzAwC+hpYFAFjy+ZMB4GtoWQCAJZ8/GQC+hpYFAFjy+ZMB4GtoWSgFMGs//qwfMHIj2IRSnmUY3dsvBWClzh0mqwD+BHyptgHQETf6x2IACFmriBTdSm+n17al3DuogI5CUQAK3OYaAL0UvT1aNfJ0z/4MmvIjoxTArP14a8/9AEiBoIh+ZF4KQC1TIUkvh1iLdJ0HT3GSNvQDfDpWcgAAAJICVpZJHuKDrNiogLjw+0wA+BpaFgBgyedPBoCvoWUBAJZ8/uRSAKN3jdHl0g8ofkfQGTjpbvNf7PQDoqnfmacAoB+QJH4zqwCIbkfTDxDAZQJQbNMPuDVEeqxG3/ZFP+CTovQDil+YZP3W7pWH+b0VG5txpvq3U2D4bV4AAICkgFXmkof4ICs2KiAuPP0A8UbMl/jaAhWQrXDHPgAAkK+AlWXJ4VmxuRfh6n7ALP9XDK1ehQoguqWbnHxLm7/ryzraSiNNjaUVSg7u7gCi++rJ61zSvLqVLb+wqXfTsaQKRUHJ4rf41GvAcS1UwjnZIfGjAHb3yn/ti5Jwutvwr7FIBUxf3Vd2CIBiugAAQLECxe6pAAAUK1DsngoAQLECxe6pAAAUK1DsngoAQLECxe6pgGIAfwFOf1ZwF7DSqwAAAABJRU5ErkJggg==", Ne = "elo-tablet", De = "elo-mobile", H = {
  "space-introduction": "elo-space-introduction",
  tablet: Ne,
  mobile: De,
  "space-introduction__content": "elo-space-introduction__content",
  "space-introduction__content__button-container": "elo-space-introduction__content__button-container",
  "space-introduction__map-container": "elo-space-introduction__map-container",
  "space-introduction__heading--show-more": "elo-space-introduction__heading--show-more",
  "space-introduction__long-desc": "elo-space-introduction__long-desc"
}, Ie = {
  width: "100%",
  height: "480px",
  borderRadius: "20px"
}, Pe = {
  fillColor: "#FFD700",
  fillOpacity: 1,
  strokeColor: "#FFD700",
  strokeOpacity: 1,
  strokeWeight: 2
}, $e = ({
  type: t = "office",
  googleMapsApiKey: e,
  lat: r,
  lng: i,
  label: l,
  showMoreButtonText: s,
  showLessButtonText: c,
  shortDescription: f,
  longDescription: d,
  downloadFloorPlanButtonText: g,
  open3DModelButtonText: m,
  openModal: S,
  showModal: w,
  downloadableImage: y,
  showMoreHeading: A = !1
}) => {
  const { isLoaded: D, loadError: I } = pe({
    googleMapsApiKey: e
  }), [u, a] = Q(15), [x, L] = Q(!1), [P, T] = Q(
    A && f.length > 400
  ), N = te("(min-width: 1024px)"), k = te("(max-width: 600px)");
  if (I) return /* @__PURE__ */ n("div", { children: "Error loading maps" });
  if (!D) return /* @__PURE__ */ n(re, {});
  const b = r && i ? { lat: r, lng: i } : void 0, v = {
    mapTypeControl: !1,
    streetViewControl: !1,
    fullscreenControl: !1,
    keyboardShortcuts: !1,
    zoomControl: !1,
    styles: fe,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_BOTTOM
    }
  }, E = {
    width: 24 + (u - 15) * 2,
    height: 24 + (u - 15) * 2
  }, p = {
    left: 12 + (u - 15),
    top: 12 + (u - 15)
  }, F = u <= 9 ? 3e3 : u <= 10 ? 1e3 : {
    11: 560,
    12: 360,
    13: 200,
    14: 100,
    15: 70,
    16: 40,
    17: 30,
    18: 25,
    19: 20,
    20: 14
  }[u] || 44, O = (C) => {
    a(C.getZoom() || 15);
  }, G = R(H["space-introduction__heading"], {
    [H["space-introduction__heading--show-more"]]: P
  });
  return /* @__PURE__ */ _("div", { id: "space-introduction", className: H["space-introduction"], children: [
    /* @__PURE__ */ _("div", { className: H["space-introduction__content"], children: [
      /* @__PURE__ */ _("div", { children: [
        /* @__PURE__ */ n(h, { type: "label", size: "large", children: l }),
        /* @__PURE__ */ n(h, { type: "heading", size: "small", extraClass: G, children: /* @__PURE__ */ n(ie, { htmlString: f }) }),
        A && f.length > 400 && /* @__PURE__ */ n(
          K,
          {
            variant: "ghost",
            iconRight: P ? "ArrowDownAlt" : "ArrowUpAlt",
            onClick: () => T((C) => !C),
            children: P ? s : c
          }
        ),
        t === "building" && d && /* @__PURE__ */ n(h, { type: "paragraph", size: "medium", children: x && /* @__PURE__ */ n(ie, { htmlString: d, className: H["space-introduction__long-desc"] }) }),
        t === "building" && d && /* @__PURE__ */ n(
          K,
          {
            variant: "ghost",
            iconRight: x ? "ArrowUpAlt" : "ArrowDownAlt",
            onClick: () => L((C) => !C),
            children: x ? c : s
          }
        )
      ] }),
      N && t === "office" && /* @__PURE__ */ _(
        "div",
        {
          className: H["space-introduction__content__button-container"],
          children: [
            y && g && /* @__PURE__ */ n(
              J,
              {
                iconLeft: "Download",
                variant: "primary",
                download: !0,
                href: y,
                children: g
              }
            ),
            w && /* @__PURE__ */ n(
              K,
              {
                iconLeft: "Cube",
                small: k,
                variant: "secondary",
                onClick: S || (() => {
                }),
                children: m
              }
            )
          ]
        }
      )
    ] }),
    /* @__PURE__ */ n("div", { className: H["space-introduction__map-container"], children: b ? /* @__PURE__ */ _(
      me,
      {
        mapContainerStyle: Ie,
        center: b,
        zoom: u,
        options: { ...v, gestureHandling: "none" },
        onLoad: (C) => O(C),
        clickableIcons: !1,
        children: [
          /* @__PURE__ */ n(
            be,
            {
              center: b,
              radius: F,
              options: {
                ...Pe
              }
            }
          ),
          /* @__PURE__ */ n(
            ye,
            {
              position: b,
              icon: {
                url: Le,
                scaledSize: new google.maps.Size(
                  E.width,
                  E.height
                ),
                anchor: new google.maps.Point(
                  p.left,
                  p.top
                )
              }
            }
          ),
          /* @__PURE__ */ _(ge, { position: "LEFT_BOTTOM", children: [
            /* @__PURE__ */ n(
              oe,
              {
                isRounded: !0,
                variant: "secondary",
                id: "zoom-in-button",
                icon: "Plus",
                onClick: () => a((C) => Math.min(C + 1, 21))
              }
            ),
            /* @__PURE__ */ n(
              oe,
              {
                isRounded: !0,
                variant: "secondary",
                id: "zoom-out-button",
                icon: "Minus",
                onClick: () => a((C) => Math.max(C - 1, 0))
              }
            )
          ] })
        ]
      }
    ) : /* @__PURE__ */ n(re, {}) }),
    !N && t === "office" && /* @__PURE__ */ _(
      "div",
      {
        className: H["space-introduction__content__button-container"],
        children: [
          y && /* @__PURE__ */ n(
            J,
            {
              iconLeft: "Download",
              variant: "primary",
              download: !0,
              href: y,
              children: g
            }
          ),
          w && /* @__PURE__ */ n(
            K,
            {
              iconLeft: "Cube",
              small: k,
              variant: "secondary",
              onClick: S || (() => {
              }),
              children: m
            }
          )
        ]
      }
    )
  ] });
}, Fe = [
  "WorkSpaces",
  "Wifi",
  "User",
  "Tune",
  "Trolley",
  "Tree",
  "Square",
  "Shower",
  "Search",
  "Scene",
  "Savings",
  "Sauna",
  "Ramen",
  "ProgressActivity",
  "Plus",
  "Play",
  "PetSupplies",
  "Person",
  "Pause",
  "Parking",
  "Minus",
  "Metro",
  "MeetingRoom",
  "Map",
  "Mall",
  "Location",
  "LocalLaundryService",
  "Linkedin",
  "Instagram",
  "Image",
  "Home",
  "Help",
  "HeartOutline",
  "HeartFilled",
  "Hanger",
  "Garage",
  "Floor",
  "Favourite",
  "FamilyHome",
  "Facebook",
  "ExternalLink",
  "Exercise",
  "EventAvailable",
  "Euro",
  "EnergySaving",
  "EloLogo",
  "Elevator",
  "Edit",
  "Earth",
  "Download",
  "DoorOpen",
  "DirectionsRailway",
  "Cube",
  "CropFree",
  "Corporate",
  "Contact",
  "Concierge",
  "Close",
  "Check",
  "Calender",
  "Calculate",
  "Burger",
  "Build",
  "Bolt",
  "Bike",
  "Badge",
  "ArrowUp",
  "ArrowUpAlt",
  "ArrowRightAlt",
  "ArrowLeftAlt",
  "ArrowForward",
  "ArrowDown",
  "ArrowDownAlt",
  "ArrowBack"
], Me = "elo-tablet", ze = "elo-desktop", X = {
  "info-card__heading": "elo-info-card__heading",
  tablet: Me,
  desktop: ze,
  "info-card__grid": "elo-info-card__grid",
  "info-card__grid--desktop-5": "elo-info-card__grid--desktop-5"
}, ce = {
  Aulapalvelut: "Concierge",
  "Lounas/Catering": "Ramen",
  Neuvottelutilat: "DoorOpen",
  Ympäristösertifioitu: "EnergySaving",
  Kuntosali: "Exercise",
  Pyöräparkki: "Bike",
  "Suihku- ja pukuhuonetilat": "Shower",
  Pysäköinti: "Parking",
  Muuttovalmis: "Hanger",
  "Kiinteiston nimi": "Corporate",
  Osoite: "Map",
  "Tekninen tyyppi": "WorkSpaces",
  Rakennusvuosi: "Build",
  Omistaja: "FamilyHome",
  "Pinta-ala": "CropFree",
  "Kerros lkm": "Floor",
  Energiatehokkuus: "Bolt",
  Sertifikaatti: "EnergySaving",
  Hissi: "Elevator",
  Laajakaista: "Wifi",
  "Lemmikit sallittu": "PetSupplies",
  Sauna: "Sauna",
  Juna: "DirectionsRailway",
  Kerhohuone: "Scene",
  Pesutupa: "LocalLaundryService",
  "Taloyhtiön sauna": "Sauna",
  Autohalli: "Garage",
  Metro: "Metro",
  "Asuntoyhtiön nimi": "Corporate",
  Asuntoja: "FamilyHome",
  Kerroksia: "Floor",
  Energiatehokkuusluokka: "Bolt"
}, Xe = ee.forwardRef(
  ({
    heading: t,
    isTransparent: e = !1,
    hasFiveColumns: r = !1,
    infoCardData: i = []
  }, l) => {
    const s = R(X["info-card__grid"], {
      [X["info-card__grid--desktop-5"]]: r
    });
    return /* @__PURE__ */ _(de, { children: [
      t && /* @__PURE__ */ n(
        h,
        {
          type: "heading",
          size: "medium",
          extraClass: X["info-card__heading"],
          children: t
        }
      ),
      /* @__PURE__ */ n("div", { className: s, ref: l, children: i.map((c, f) => {
        let d = "transparent";
        if (!e)
          switch ((f + 1) % 4) {
            case 1:
              d = "primary";
              break;
            case 2:
              d = "secondary";
              break;
            case 3:
              d = "tertiary";
              break;
            case 0:
              f >= 3 && (d = "quaternary");
              break;
          }
        return /* @__PURE__ */ n(
          ve,
          {
            icon: Re(c),
            type: d,
            title: c.title,
            description: c.description
          },
          f
        );
      }) })
    ] });
  }
);
function Y(t) {
  return t ? Fe.includes(t) : !1;
}
function Re({
  title: t,
  iconName: e
}) {
  if (e) {
    if (Y(e))
      return e;
    const i = ce[e];
    if (Y(i))
      return i;
  }
  const r = ce[t];
  return Y(r) ? r : "Check";
}
export {
  Ze as C,
  Ue as F,
  Xe as I,
  $e as S,
  We as a,
  je as b,
  ve as c
};
